"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeValueEditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _emotion = require("emotion");

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _ValidationResultDisplay = require("../../shared/ValidationResultDisplay");

var _propTypes2 = require("../../shared/propTypes");

var _options = require("../../shared/enums/options");

var _rangeValidators = require("../../shared/validators/rangeValidators");

var _range = require("../../shared/mappers/range");

var _commonStyles = require("../../shared/commonStyles");

var _flexStyles = require("../../shared/flexStyles");

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  max-width: 600px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex: 2;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 48px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var textFieldHeight = (0, _emotion.css)(_templateObject());
var flexOne = (0, _emotion.css)(_templateObject2());
var flexTwo = (0, _emotion.css)(_templateObject3());
var maxRangeFormWidth = (0, _emotion.css)(_templateObject4());
var UPDATE_MINMAX = 'UPDATE_MINMAX';
var UPDATE_INCREMENT = 'UPDATE_INCREMENT';
var RESET_RANGE_STATE = 'RESET_RANGE_STATE';
var MIN_MAX_REGEX = /^([^-]+)((-)?(.*)|[+])?$/i;
var MIN_IDX = 1;
var HYPHEN_IDX = 3;
var MAX_IDX = 4;

var computeRangeString = function computeRangeString(_ref) {
  var minMax = _ref.minMax,
      increment = _ref.increment;
  var matches = minMax.trim().match(MIN_MAX_REGEX);

  if (matches) {
    return (0, _range.mapRangeToText)({
      minimum: matches[MIN_IDX],
      maximum: matches[HYPHEN_IDX] ? matches[MAX_IDX] : matches[MIN_IDX],
      increment: increment
    });
  }

  return '';
};

var computeRangeState = function computeRangeState(state, action) {
  switch (action.type) {
    case UPDATE_MINMAX:
      return _objectSpread(_objectSpread({}, state), {}, {
        minMax: action.payload
      });

    case UPDATE_INCREMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        increment: action.payload
      });

    case RESET_RANGE_STATE:
      return {
        minMax: '',
        increment: ''
      };

    default:
      throw new Error('Unknown action type received');
  }
};

var RangeValueEditor = function RangeValueEditor(_ref2) {
  var existingValues = _ref2.existingValues,
      validValues = _ref2.validValues,
      onValueAdded = _ref2.onValueAdded,
      enforceValidValues = _ref2.enforceValidValues;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useReducer = (0, _react.useReducer)(computeRangeState, {
    minMax: '',
    increment: ''
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      rangeState = _useReducer2[0],
      updateRangeState = _useReducer2[1];

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      validationState = _useState2[0],
      updateValidationState = _useState2[1];

  (0, _react.useEffect)(function () {
    var rangeString = computeRangeString(rangeState);
    var updatedValidationState = (0, _rangeValidators.validateRangeString)(rangeString, existingValues, validValues, enforceValidValues);
    updateValidationState(updatedValidationState);
  }, [rangeState, existingValues, validValues, enforceValidValues]);

  var onFormSubmit = function onFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    onValueAdded({
      type: _options.RANGE,
      range: validationState.range
    });
    updateRangeState({
      type: RESET_RANGE_STATE
    });
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement("form", {
      className: (0, _emotion.cx)(_flexStyles.flexParent, maxRangeFormWidth),
      onSubmit: onFormSubmit
    },
    /*#__PURE__*/
    _react["default"].createElement(_TextField["default"], {
      className: (0, _emotion.cx)(flexTwo, _commonStyles.thirtyPxMarginRight),
      label: formatMessage(_messages["default"].minMax),
      value: rangeState.minMax,
      onChange: function onChange(e) {
        return updateRangeState({
          type: UPDATE_MINMAX,
          payload: e.target.value
        });
      },
      "data-testid": 'MinMaxField'
    }),
    /*#__PURE__*/
    _react["default"].createElement(_TextField["default"], {
      className: (0, _emotion.cx)(flexOne, _commonStyles.thirtyPxMarginRight),
      label: formatMessage(_messages["default"].incrementWithoutUnit),
      value: rangeState.increment,
      onChange: function onChange(e) {
        return updateRangeState({
          type: UPDATE_INCREMENT,
          payload: e.target.value
        });
      },
      "data-testid": 'IncrementField'
    }),
    /*#__PURE__*/
    _react["default"].createElement(_Button["default"], {
      type: "default",
      className: textFieldHeight,
      disabled: validationState.range === undefined || validationState.errors.length !== 0,
      "data-testid": 'AddRangeButton'
    }, formatMessage(_messages["default"].addNew))),
    /*#__PURE__*/
    _react["default"].createElement(_ValidationResultDisplay.ValidationResultDisplay, {
      errors: validationState.errors,
      warnings: validationState.warnings
    }))
  );
};

exports.RangeValueEditor = RangeValueEditor;
RangeValueEditor.propTypes = {
  existingValues: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)),
  validValues: _propTypes["default"].arrayOf(_propTypes["default"].shape(_propTypes2.valueShape)),
  onValueAdded: _propTypes["default"].func.isRequired,
  enforceValidValues: _propTypes["default"].bool
};
RangeValueEditor.defaultProps = {
  existingValues: [],
  enforceValidValues: false
};